import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import InquiryService from 'services/inquiry';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InfoIcon from '@material-ui/icons/Info';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';

function InquiryBidFreightageDetail(props) {
  const Config = {
    purchase: {
      title: '供应商竞价详情',
      apiPath: '/logistics/bidding/getDetail',
      publishApiPath: '/logistics/bidding/publish',
      cancelApiPath: '/logistics/bidding/cancel',
      puResultApiPath: '/logistics/bidding/publishResult',
      confirmCuBidApiPath: '/logistics/cbidding/biddingChoose',
      enumMainKey: 'B02_Bid_Status',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Bid_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'lboXkNo',
      wfmCode: '1010'
    },
    sale: {
      title: '客户竞价详情',
      apiPath: '/logistics/cbidding/getDetail',
      enumMainKey: 'B02_Bid_Status',
      companyNameKey: 'innerCustomerName',
      confirmCuBidApiPath: '/logistics/cbidding/biddingChoose',
      quPriceBidApiPath: '/logistics/cbidding/quote/add',
      arrEnumField: [
        {
          mainKey: 'B02_Bid_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'lboXkNo'
    }
  };

  const styles = theme => ({
    quoteBt: {
      height: 32,
      borderRadius: '4px',
      marginTop: 10,
      float: 'right'
    }
  });

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);
  self.idField = 'lboXkNo';
  self.countTimer = 0;
  self.countDownTimer = 0;

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [currentBidInfo, setCurrentBidInfo] = useState({});
  const [vendorQuoteList, setVendorQuoteList] = useState([]);
  const [myQuoteList, setMyQuoteList] = useState([]);
  const [countDown, setCountDown] = useState();
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [quoteBottom, setQuoteBottom] = useState(false);

  const [paramVar, setParamVar] = useState({});
  const [myQuotePrice, setMyQuotePrice] = useState('');
  const [vendorDescription, setVendorDescription] = useState('');
  const [primaryQuoteData, setPrimaryQuoteData] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      data.vendorList.forEach(vendor => {
        EnumService.getValue(
          'B02_Bid_Confirm_Flag',
          vendor.confirmBiddingFlag
        ).then(value => {
          vendor.confirmBiddingFlagName = value;
          forceUpdate();
        });
      });
    } else {
      EnumService.getValue(
        'B02_Bid_Confirm_Flag',
        data.confirmBiddingFlag
      ).then(value => {
        data.confirmBiddingFlagName = value;
        forceUpdate();
      });
    }

    data.taxRate = data.taxRate * 100;
    data.priceContainTaxName =
      data.priceContainTaxFlag === 0
        ? '不限'
        : data.priceContainTaxFlag === 1
        ? '含税价'
        : '未税价';
    data.quoteCurrencyName = data.quoteCurrencyName || '人民币'; //默认人民币
    setDetail(data);
    getBidStatistics(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  //当前竞价统计信息
  function getBidStatistics(detailData) {
    let postbody = {
      lboXkNo: self.id,
      companyCode: companyCode,
      apiPath: '/logistics/cbidding/quote/currentBidStatistics'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let statisticsArr = response.data;
        detailData.lineList.forEach(item => {
          statisticsArr.forEach(val => {
            if (item.lineNo === val.lineNo) {
              item = Object.assign(item, val);
            }
          });
          forceUpdate();
        });
        setDetail(detailData);
      }
    });
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      lboXkNo: detail.lboXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 切换tab
  function handleNav(event, type) {
    setCurrNavIndex(Number(type));
    if (Number(type) === 1) {
      refreshQuoteData();
    } else {
      clearInterval(self.countTimer);
      clearInterval(self.countDownTimer);
    }
  }

  // 项目竞价
  function refreshQuoteData() {
    clearInterval(self.countTimer);
    clearInterval(self.countDownTimer);
    let fn = () => {
      if (self.isPurchase) {
        getCurrentBidInfo();
        getQuoteDetail();
      } else {
        getMyQuoteList();
        getCurrentBidInfoSale();
        getQuoteDetailSale();
      }
    };
    if (detail.status !== 1) {
      fn();
    }
    if (detail.status === 2) {
      initCountDown();
      self.countTimer = setInterval(fn, 60 * 1000);
    }
  }

  // 获取当前价格统计
  function getCurrentBidInfo() {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      bidLineNo: 1,
      companyCode: companyCode,
      apiPath: '/bidding/quote/currentBidInfo'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      let format = n => {
        let prefix = n > 0 ? '+' : '';
        return prefix + n.toFixed(0) + '%';
      };
      if (response.success) {
        let data = response.data || {};
        let n;
        if (data.currMinPrice !== null && data.histoMinPrice !== null) {
          n =
            ((data.currMinPrice - data.histoMinPrice) / data.histoMinPrice) *
            100;
          data.percentMin = format(n);
          data.deltaMin = data.currMinPrice - data.histoMinPrice;
        }
        if (data.currAvgPrice !== null && data.histoAvgPrice !== null) {
          n =
            ((data.currAvgPrice - data.histoAvgPrice) / data.histoAvgPrice) *
            100;
          data.percentAvg = format(n);
          data.deltaAvg = data.currAvgPrice - data.histoAvgPrice;
        }
        if (data.currMaxPrice !== null && data.histoMaxPrice !== null) {
          n =
            ((data.currMaxPrice - data.histoMaxPrice) / data.histoMaxPrice) *
            100;
          data.percentMax = format(n);
          data.deltaMax = data.currMaxPrice - data.histoMaxPrice;
        }
        setCurrentBidInfo(data);
      }
    });
  }

  // 获取报价详情
  function getQuoteDetail() {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      callerType: 1,
      companyCode: companyCode,
      apiPath: '/bidding/quote/getQuoteDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let arr = response.data || [];
        //[比价中，已完成]
        if ([4, 5].includes(detail.status)) {
          //根据最终价格排序
          let list = arr
            .filter(item => item.quoteList !== null)
            .sort((a, b) => b.createtime - a.createTime)
            .sort(
              (a, b) => a.quoteList[0].quotePrice - b.quoteList[0].quotePrice
            );

          genFinalQuoteList(list);
          setVendorQuoteList(list);
        } else if (detail.status === 2) {
          setVendorQuoteList(arr);
        }
      }
    });
  }

  // 获取我的报价列表（供应商）
  function getMyQuoteList() {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/myQuoteList'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];
        setMyQuoteList(list);
      }
    });
  }

  // 获取当前价格统计（供应商）
  function getCurrentBidInfoSale() {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      bidLineNo: 1,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/currentBidInfo'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data || {};
        setCurrentBidInfo(data);
      }
    });
  }
  // 获取报价详情（供应商）
  function getQuoteDetailSale() {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      callerType: 2,
      companyCode: companyCode,
      apiPath: '/bidding/quote/getQuoteDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];
        list.forEach(item => {
          item.isSelf = item.vendorCode === self.companyCode;
        });
        setVendorQuoteList(list);
      }
    });
  }
  //生成最终报价数据
  function genFinalQuoteList(list) {
    let total = 0;
    let arr = list
      .filter(vendor => vendor.quoteList !== null)
      .map(vendor => {
        let quoteList = vendor.quoteList
          .slice(0)
          .sort((a, b) => b.createTime - a.createTime);
        let { quotePrice } = quoteList[0];
        total += quotePrice;
        return {
          quotePrice: '',
          createName: '',
          vendorCode: '',
          avgPrice: 0,
          checked: vendor.quoteSelectedFlag === 1,
          innerVendorName: vendor.innerVendorName,
          vendorXkUniqueCode: vendor.vendorXkUniqueCode
        };
      });
    arr.sort((a, b) => a.quotePrice - b.quotePrice);
  }

  //初始化倒计时
  function initCountDown() {
    let delta = detail.bidEndDate - Date.now();
    delta = Math.floor(delta / 1000);
    let padZero = n => {
      if (n < 10) {
        return '0' + n;
      }
      return n;
    };
    let fn = () => {
      delta -= 1;
      if (delta < 0) {
        clearInterval(self.countDownTimer);
        return;
      }
      let h = Math.floor(delta / 3600);
      let m = Math.floor(delta / 60) - h * 60;
      let s = Math.floor(delta % 60);
      let count = padZero(h) + ' : ' + padZero(m) + ' : ' + padZero(s);
      setCountDown(count);
    };
    if (delta > 0) {
      self.countDownTimer = setInterval(fn, 1000);
    }
  }

  // 修改报价信息
  function handleQuoteChange(event) {
    let val = Util.qtyChange(event.target.value);
    setMyQuotePrice(val);
    setParamVar({
      quotePrice: val,
      isBackTxtError: false,
      isBackTxtError2: false
    });
  }

  // 确定报价按钮
  function sureQuoteClick() {
    let lastPrice =
      myQuoteList.length > 0 ? myQuoteList[0].quotePrice : Infinity;
    if (/^\d+(\.\d+)?$/.test(myQuotePrice) === false) {
      setParamVar({ isBackTxtError: true, isBackTxtError2: false });
      return;
    }
    if (detail.quoteLessFlag === 1 && parseFloat(myQuotePrice) >= lastPrice) {
      setParamVar({ isBackTxtError: false, isBackTxtError2: true });
      return;
    }
    handle('quotePrice');
  }

  function handle(type) {
    switch (type) {
      case '1':
        confirmCustomerBidding(1);
        break;
      case '2':
        confirmCustomerBidding(2);
        break;
      case '3':
        publishBidding();
        break;
      case '4':
        cancelBidding();
        break;
      case '5':
        publishResult();
        break;
      case 'quotePrice':
        quotePriceBidding();
        break;
      default:
    }
  }

  // 发布竞价
  function publishBidding() {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 取消竞价
  function cancelBidding() {
    let postbody = getPostbody(config.cancelApiPath);
    InquiryService.cancelBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 发布竞价结果
  function publishResult() {
    let postbody = getPostbody(config.puResultApiPath);
    InquiryService.publishResult(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 供应商确认竞价 || 放弃
  function confirmCustomerBidding(type) {
    let postbody = getPostbody(config.confirmCuBidApiPath);
    postbody.confirmBiddingFlag = type;
    InquiryService.confirmCustomerBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 报价
  function quotePriceBidding() {
    let postbody = getPostbody(config.quPriceBidApiPath);
    postbody.lboLineNo = primaryQuoteData.lineNo;
    postbody.quotePrice = myQuotePrice;
    postbody.vendorDescription = vendorDescription;
    InquiryService.quotePriceBidding(
      postbody,
      () => {
        // self.getDetail();
        setMyQuotePrice('');
        setQuoteBottom(false);
        refreshQuoteData();
        getBidStatistics(detail);
      },
      dispatch
    );
  }

  // 修改描述信息
  function handleVendorDescriptionChange(event) {
    let val = event.target.value;
    setVendorDescription(val);

    setParamVar({
      quotePrice: myQuotePrice,
      vendorDescription: vendorDescription,
      isBackTxtError: false,
      isBackTxtError2: false
    });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 1 && (
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={currNavIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleNav}
          >
            <Tab label="项目信息" />
            {/* {[1, 2, 4, 5].includes(detail.status) &&
              (self.isPurchase ||
                (!self.isPurchase && detail.confirmBiddingFlag === 1)) && (
                <Tab label={'项目竞价(' + detail.statusName + ')'} />
              )} */}
          </Tabs>
        </Paper>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">标题</span>
                    <div className="field-value">{detail.billTitle}</div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">客户</span>
                      <div className="field-value">
                        {detail.innerCustomerName}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">竞价状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Bid_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  {/* 审批流状态 仅开启后才显示 */}
                  {workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={detail.bidXkNo}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">确认状态</span>
                      <div className="field-value">
                        <span
                          className={
                            detail.confirmBiddingFlag === 1
                              ? 'green'
                              : detail.confirmBiddingFlag === 2
                              ? 'red'
                              : ''
                          }
                        >
                          {detail.confirmBiddingFlagName}
                        </span>
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">发布时间</span>
                    <div className="field-value">
                      {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">{detail.publishName}</div>
                  </li>
                  <li>
                    <span className="field-label">编号</span>
                    <div className="field-value">{detail.lboXkNo}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>竞价项目设定</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">竞价有效时间</span>
                    <div className="field-value">
                      <span className="blue">
                        {formatDate(detail.lboStartDate, 'YYYY-MM-DD HH:mm')} -{' '}
                        {formatDate(detail.lboEndDate, 'HH:mm')}
                      </span>
                    </div>
                  </li>
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">竞价控制</span>
                      <div className="field-value">
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showRankingsFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示排名"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showMaxPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示最高报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showMinPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示最低报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showAveragePriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示平均报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showVendorPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示其他供应商报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showOtherVendorNameFlag === 1
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="竞价时公示其他供应商名称"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.quoteLessFlag === 1 ? true : false
                              }
                            />
                          }
                          label="报价时价格必须低于上次报价"
                        />
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>竞价物流</label>
            </div>
            <div className="details-item-content">
              {!Util.isEmpty(detail.lineList) &&
                detail.lineList.map((item, index) => (
                  <div
                    className="content-line line-list-item"
                    key={String(item.id) + index}
                  >
                    <div className="line-list-item-title">
                      <span>项次 {item.lineNo}</span>
                    </div>
                    <ul className="field-list">
                      <li>
                        <span className="field-label">送货地点</span>
                        <div className="field-value">
                          {item.deliveryPlaceName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">地址</span>
                        <div className="field-value">
                          {item.detailedAddress}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">物流计价批量</span>
                        <div className="field-value">{item.logisticsQty}</div>
                      </li>
                      <li>
                        <span className="field-label">供应商名称</span>
                        <div className="field-value">
                          {!Util.isEmpty(item.respList) &&
                            item.respList.map(list => (vendor, j) => (
                              <div key={String(vendor.id) + j}>
                                {vendor.innerVendorName}
                              </div>
                            ))}
                        </div>
                      </li>
                    </ul>
                    {self.isPurchase &&
                      !Util.isEmpty(item.respList) &&
                      item.respList.map((prod, prodIndex) => (
                        <div key={prodIndex} className="order-detail-more">
                          {prod.priceSize && (
                            <ul key={prodIndex} className="field-list">
                              <li>
                                <span className="field-label">供应商名称</span>
                                <div className="field-value">
                                  {prod.innerVendorName}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">初次报价</span>
                                <div className="field-value">
                                  {formatNumber(
                                    prod.firstPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">报价次数</span>
                                <div className="field-value">
                                  {prod.priceSize}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">报价排名</span>
                                <div className="field-value">{prod.rank}</div>
                              </li>
                              <li>
                                <span className="field-label">最新报价</span>
                                <div className="field-value">
                                  {formatNumber(
                                    prod.lastPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">备注说明</span>
                                <div className="field-value">
                                  {prod.vendorDescription}
                                </div>
                              </li>
                            </ul>
                          )}
                        </div>
                      ))}

                    {!self.isPurchase && (
                      <div className="order-detail-more">
                        {item.lastPrice && (
                          <ul className="field-list">
                            <li>
                              <span className="field-label">报价排名</span>
                              <div className="field-value">{item.rank}</div>
                            </li>
                            <li>
                              <span className="field-label">平均价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.currAvgPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">最低价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.currMinPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">初次报价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.firstPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">报价次数</span>
                              <div className="field-value">
                                {item.priceSize}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">当前报价</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.lastPrice,
                                  decimalPlace.Price_Decimal_Place
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">备注说明</span>
                              <div className="field-value">
                                {item.vendorDescription}
                              </div>
                            </li>
                            {detail.status === 5 && (
                              <li>
                                <span className="field-label">竞价结果</span>
                                <div className="field-value">
                                  <span
                                    className={
                                      'u-sign ' +
                                      (item.quoteSelectedFlag === 0
                                        ? 'orange'
                                        : 'green')
                                    }
                                  >
                                    {item.quoteSelectedFlag === 1
                                      ? '入选'
                                      : item.quoteSelectedFlag === 0
                                      ? '未入选'
                                      : ''}
                                  </span>
                                </div>
                              </li>
                            )}
                          </ul>
                        )}
                        {!self.isPurchase &&
                          detail.status === 2 &&
                          detail.confirmBiddingFlag === 1 && (
                            <Fab
                              variant="extended"
                              color="primary"
                              size="large"
                              className={styles.quoteBt}
                              onClick={() => {
                                setQuoteBottom(true);
                                setPrimaryQuoteData(item);
                              }}
                            >
                              报价
                            </Fab>
                          )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>报价要求</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">是否含税</span>
                    <div className="field-value">
                      {detail.priceContainTaxName}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {self.isPurchase && (
            <div className="m-details-item">
              <div className="details-item-title">
                <label>竞价供应商</label>
              </div>
              <div className="details-item-content">
                {!Util.isEmpty(detail.vendorList) &&
                  detail.vendorList.map((item, index) => (
                    <div className="content-line line-list-item" key={index}>
                      <div className="line-list-item-title">
                        <span>
                          {item.innerVendorCode}-{item.innerVendorName}
                        </span>
                      </div>
                      <ul className="field-list">
                        <li>
                          <span className="field-label">类型</span>
                          <div className="field-value">
                            {item.newFlag === 0
                              ? '正式供应商'
                              : item.newFlag === 2
                              ? '潜在供应商'
                              : ''}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台名称</span>
                          <div className="field-value">
                            {item.handshakeFlag !== 2 && item.vendorName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台状态</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2 ? '已加入' : '未加入'}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">竞价确认</span>
                          <div className="field-value">
                            {item.confirmBiddingFlagName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">接收人</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2
                              ? '将自动于携客平台内通知'
                              : item.contactPerson}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">手机号码</span>
                          <div className="field-value">
                            {item.mobile ? item.mobileArea : ''} {item.mobile}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">邮箱</span>
                          <div className="field-value">{item.mailbox}</div>
                        </li>
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      )}
      {currNavIndex === 1 && (
        <div className="pb50">
          {self.isPurchase ? (
            <div>
              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>当前竞价统计</label>
                </div>
                <div className="order-detail-list">
                  <ul>
                    <li className="order-detail-item">
                      <h4>最低报价</h4>
                      <p className="mb10">
                        当前价格：
                        {formatNumber(
                          currentBidInfo.currMinPrice,
                          decimalPlace.Price_Decimal_Place
                        )}
                      </p>
                      <ul className="clearfix">
                        <li>
                          历史价格：
                          {formatNumber(
                            currentBidInfo.histoMinPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </li>
                        <li>降幅：{currentBidInfo.percentMin}</li>
                      </ul>
                    </li>
                    <li className="order-detail-item">
                      <h4>平均报价</h4>
                      <p className="mb10">
                        当前价格：
                        {formatNumber(
                          currentBidInfo.currAvgPrice,
                          decimalPlace.Price_Decimal_Place
                        )}
                      </p>
                      <ul className="clearfix">
                        <li>
                          历史价格：
                          {formatNumber(
                            currentBidInfo.histoAvgPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </li>
                        <li>降幅：{currentBidInfo.percentAvg}</li>
                      </ul>
                    </li>
                    <li className="order-detail-item">
                      <h4>最高报价</h4>
                      <p className="mb10">
                        当前价格：
                        {formatNumber(
                          currentBidInfo.currMaxPrice,
                          decimalPlace.Price_Decimal_Place
                        )}
                      </p>
                      <ul className="clearfix">
                        <li>
                          历史价格：
                          {formatNumber(
                            currentBidInfo.histoMaxPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </li>
                        <li>降幅：{currentBidInfo.percentMax}</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>竞价记录</label>
                </div>
                <div className="order-detail-list">
                  <ul>
                    {!Util.isEmpty(vendorQuoteList) &&
                      vendorQuoteList.map((vendor, index) => (
                        <li
                          className="order-detail-item"
                          key={String(vendor.id) + index}
                        >
                          <h4>{vendor.innerVendorName}</h4>
                          {!Util.isEmpty(vendor.quoteList) &&
                            vendor.quoteList.map((item, i) => (
                              <ul
                                className="clearfix"
                                key={String(item.id) + i}
                              >
                                <li>
                                  报价时间：
                                  {formatDate(item.createTime, 'HH:mm:ss')}
                                </li>
                                <li>
                                  竞价记录：
                                  {formatNumber(
                                    item.quotePrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </li>
                                <li>报价人：{item.createName}</li>
                              </ul>
                            ))}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>当前竞价信息</label>
                </div>
                <ul>
                  <li>
                    <label className="order-detail-label">当前排名</label>
                    <div className="order-detail-value">
                      {currentBidInfo.rank}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前最高报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currMaxPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前最低报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currMinPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前平均报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currAvgPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                </ul>
              </div>

              <div className="order-detail-block">
                <div className="order-detail-list">
                  <ul>
                    {!Util.isEmpty(myQuoteList) &&
                      myQuoteList.map((quote, index) => (
                        <li
                          className="order-detail-item"
                          key={String(quote.id) + index}
                        >
                          <h4>
                            {formatDate(
                              quote.createTime,
                              'YYYY-MM-DD HH:mm:ss'
                            )}
                          </h4>
                          <ul className="clearfix">
                            <li>
                              报价价格：
                              {formatNumber(
                                quote.quotePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </li>
                            <li>报价人：{quote.createName}</li>
                          </ul>
                        </li>
                      ))}
                  </ul>
                  {detail.status === 2 && detail.quoteLessFlag === 1 && (
                    <div className="quoProductsList wid100">
                      <InfoIcon
                        className="verticalMiddle mr5"
                        color="primary"
                        fontSize="small"
                      />
                      报价必须低于上次报价
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {!self.isPurchase && User.checkAuth('20050302') && (
        <Drawer
          anchor="bottom"
          open={quoteBottom}
          onClose={() => setQuoteBottom(false)}
        >
          <div tabIndex={0} role="button">
            <div className="MuiDrawer-paper">
              <div className="text-field-item">
                <TextField
                  label="我的报价"
                  value={myQuotePrice}
                  onChange={event => handleQuoteChange(event)}
                  margin="normal"
                  variant="outlined"
                />
                {paramVar.isBackTxtError && (
                  <div className="red">价格格式不正确</div>
                )}
                {paramVar.isBackTxtError2 && (
                  <div className="red">价格必须低于上次报价</div>
                )}
              </div>
              <div className="text-field-item">
                <TextField
                  label="备注说明"
                  value={vendorDescription || ''}
                  onChange={event => handleVendorDescriptionChange(event)}
                  margin="normal"
                  rows="3"
                  multiline
                  fullWidth
                  variant="outlined"
                />
              </div>
              <p className="mt15 m-flex-box">
                <Button
                  type="default"
                  onClick={() => sureQuoteClick()}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  确定
                </Button>
                <Button
                  type="default"
                  onClick={() => {
                    setParamVar({
                      quotePrice: '',
                      isBackTxtError: false,
                      isBackTxtError2: false
                    });
                    setQuoteBottom(false);
                    setMyQuotePrice('');
                  }}
                  className="m-flex-item u-btn u-btn_line"
                >
                  取消
                </Button>
              </p>
            </div>
          </div>
        </Drawer>
      )}

      {!self.isPurchase &&
        User.checkAuth('20070302') &&
        [1, 2].includes(detail.status) &&
        detail.confirmBiddingFlag === 0 && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                handle('1');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认参与
            </Button>
            <Button
              type="default"
              onClick={() => {
                handle('2');
              }}
              className="m-flex-item u-btn u-btn_line"
            >
              本次弃权
            </Button>
          </div>
        )}

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10070305') &&
            detail.status === 0 &&
            workflow.data &&
            workflow.data['logistics_bid_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('3');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
          {User.checkAuth('10070304') && [1, 2].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handle('4');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              取消竞价
            </Button>
          )}
          {User.checkAuth('10070304') && detail.status === 4 && (
            <Button
              type="default"
              onClick={() => {
                handle('5');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              发布竞价结果
            </Button>
          )}
        </div>
      )}

      <Modal></Modal>
    </div>
  );
}

InquiryBidFreightageDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InquiryBidFreightageDetail);
